// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b1834d73","455":"0dd45a39","977":"f8e2307a"}[chunkId] + ".chunk.js";
};